import React from 'react';
import { ButtonProps, Dropdown } from 'react-bootstrap';

import Icon from '../icon/Icon';

import './ActionDropdown.scss';

const ActionDropdown: React.FC = ({ children }) => {
  const ToggleButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ onClick }, ref) => (
    <button
      ref={ref}
      className="action-dropdown__button button button--transparent"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }}
    >
      <Icon icon="threeDots" size="small" height={18} svg className="actoion-dropdown__icon" />
    </button>
  ));
  return (
    <Dropdown alignRight className="action-dropdown">
      <Dropdown.Toggle as={ToggleButton} variant="transparent" />
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Dropdown>
  );
};

export default ActionDropdown;
